export const SENDER_TYPE = 'senderType';
export const SENDER_ID = 'senderId';